export enum AuxiliaryRequestState {
    REFERRED_OUT_TO_ME = 'referred-out-to-me'
}
